<template>
  <div class="scroll-cta type-mono">↓ Scroll to explore</div>
</template>

<script setup lang="ts">
const props = defineProps({})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";
</style>
